import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
//const template: string = require('./myModal.html');

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html'
})
export class ConfirmationPopupComponent implements OnInit {

  @Input('show-modal') showModal: boolean=false;
  @Input('title') title: string;
  @Input('sub-title') subTitle: string;
  @Input('cancel-label') cancelLabel: string;
  @Input('positive-label') positiveLabel: string;
  id: any;
  index: any;
  @Output('closed') closeEmitter: EventEmitter<ModalResult> = new EventEmitter<ModalResult>();
  @Output('loaded') loadedEmitter: EventEmitter<ConfirmationPopupComponent> = new EventEmitter<ConfirmationPopupComponent>();
  @Output() positiveLabelAction = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.loadedEmitter.next(this);
  }

  show() {
    this.showModal = true;
  }

  showWithParam(title: any, subTitle: any, id: any, index: any) {
    this.title = title;
    this.subTitle = subTitle;
    this.id = id;
    this.index = index;
    this.showModal = true;
  }

  hide() {
    this.showModal = false;
    this.closeEmitter.next({
      action: ModalAction.POSITIVE
    });
  }

  positiveAction() {
    this.positiveLabelAction.next(this);
    return false;
  }

  cancelAction() {
    this.showModal = false;
    this.closeEmitter.next({
      action: ModalAction.CANCEL
    });
    return false;
  }

  closeModel() {
    this.hide();
  }


}

export enum ModalAction { POSITIVE, CANCEL }

export interface ModalResult {
  action: ModalAction;
}



// WEBPACK FOOTER //
// ./src/app/components/common/confirmation-popup/confirmation-popup.component.ts